import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Stack,
} from '@mui/material';

/**
 * Dialog formulaire admin — layout standard (titre, contenu, actions).
 * Les champs (validation, helperText) restent gérés par le parent.
 */
export default function AdminFormDialog({
  open = true,
  title,
  onClose,
  onSubmit,
  submitLabel = 'Enregistrer',
  cancelLabel = 'Annuler',
  saving = false,
  submitDisabled = false,
  maxWidth = 'sm',
  children,
}) {
  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth={maxWidth} fullWidth>
      <DialogTitle sx={{ pb: 1, fontWeight: 700 }}>{title}</DialogTitle>
      <DialogContent>
        <Stack spacing={1.75} sx={{ mt: 0.5 }} component="form" id="admin-form-dialog" onSubmit={(e) => {
          e.preventDefault();
          if (!saving && !submitDisabled) onSubmit?.(e);
        }}>
          {children}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={saving}>
          {cancelLabel}
        </Button>
        <Button
          type="submit"
          form="admin-form-dialog"
          variant="contained"
          disabled={saving || submitDisabled}
        >
          {saving ? 'Enregistrement…' : submitLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
